var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 21,
    viewBox: "0 0 5 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14286 8.72675C3.33333 8.72675 4.28571 9.70236 4.28571 10.9219C4.28571 12.1414 3.33333 13.117 2.14286 13.117C0.952381 13.117 0 12.1414 0 10.9219C0 9.70236 0.952381 8.72675 2.14286 8.72675ZM0 3.117C0 4.33651 0.952381 5.31212 2.14286 5.31212C3.33333 5.31212 4.28571 4.33651 4.28571 3.117C4.28571 1.89748 3.33333 0.921875 2.14286 0.921875C0.952381 0.921875 0 1.89748 0 3.117ZM0 18.7268C0 19.9463 0.952381 20.9219 2.14286 20.9219C3.33333 20.9219 4.28571 19.9463 4.28571 18.7268C4.28571 17.5072 3.33333 16.5316 2.14286 16.5316C0.952381 16.5316 0 17.5072 0 18.7268Z",
    fill: "#7D90B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.77b156b19b123929538adbe6bb1beb0f.svg";
export { ForwardRef as ReactComponent };